import createFailure from './create/failure';
import createRequest from './create/request';
import createSuccess from './create/success';

const reducers = {
  createFailure,
  createRequest,
  createSuccess,
};

export default reducers;
